import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Cell, Column, Table } from 'fixed-data-table-2';
import TextCell from '../../../components/TextCell/TextCell';
import { DateType } from '../../../containers/UIhelper/UIDateFormater';

const _ = require('lodash');

const PRESSURE_CONVERSION = {
  meter: { factor: 1, label: 'Meter' },
  bar: { factor: 0.09804139432, label: 'Bar' },
  kpa: { factor: 9.80665, label: 'kPa' },
  psi: { factor: 1.42233, label: 'PSI' },
};

require('../SensorInfo/SensorInfo.scss');

class PressureSensorAlarmsTab extends React.Component {
  constructor(props) {
    super(props);

    this.onRowClick = this.onRowClick.bind(this);
    this.rowClassNameGetter = this.rowClassNameGetter.bind(this);
  }

  onRowClick(event, rowIndex) {
    this.props.selectPressureAlarm(this.props.pressureAlarms[rowIndex]);
  }

  rowClassNameGetter(rowIndex) {
    const { selectedPressureAlarm, pressureAlarms } = this.props;
    return selectedPressureAlarm !== null &&
      pressureAlarms[rowIndex] &&
      selectedPressureAlarm.alarm_time === pressureAlarms[rowIndex].alarm_time
      ? 'active-row'
      : '';
  }

  getAlarmTypeLabel(alarmType) {
    return alarmType === 0 ? this.context.t('alarm_type_low') : this.context.t('alarm_type_high');
  }

  render() {
    const {
      pressureAlarms,
      uiInfo,
      projectTimeZone,
      timeZone,
      pressureUnit,
    } = this.props;

    const pWidth = 0.395 * (uiInfo.pageWidth - 10);
    const pHeight = 0.494 * uiInfo.pageHeight - 8;

    const conversion = PRESSURE_CONVERSION[pressureUnit] || PRESSURE_CONVERSION.meter;
    const rawData = pressureAlarms !== null && !_.isEmpty(pressureAlarms) ? pressureAlarms : [];
    const data = rawData.map((alarm) => ({
      ...alarm,
      value_m: alarm.value_m != null ? (parseFloat(alarm.value_m) * conversion.factor).toFixed(2) : alarm.value_m,
    }));

    return (
      <div>
        <Table
          rowsCount={data.length}
          width={pWidth}
          onRowClick={this.onRowClick}
          rowClassNameGetter={this.rowClassNameGetter}
          maxHeight={pHeight - 60}
          headerHeight={46}
          rowHeight={30}
        >
          <Column
            columnKey='alarm_time'
            header={<Cell>{this.context.t('alarm_time')}</Cell>}
            cell={
              <TextCell
                data={data}
                field='alarm_time'
                dateType={DateType.DATE_AND_TIME_WITH_SECONDS}
                additional={timeZone}
                projectTimezone={projectTimeZone}
              />
            }
            width={150}
            flexGrow={1}
          />
          <Column
            columnKey='alarm_type'
            header={<Cell>{this.context.t('alarm_type')}</Cell>}
            cell={({ rowIndex, ...cellProps }) => (
              <Cell {...cellProps}>
                {data[rowIndex] ? this.getAlarmTypeLabel(data[rowIndex].alarm_type) : ''}
              </Cell>
            )}
            width={100}
            flexGrow={1}
            align='center'
          />
          <Column
            columnKey='value_m'
            header={<Cell>{`${this.context.t('alarm_value')} (${conversion.label})`}</Cell>}
            cell={<TextCell data={data} field='value_m' />}
            width={100}
            flexGrow={1}
            align='center'
          />
        </Table>
      </div>
    );
  }
}

PressureSensorAlarmsTab.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  pressureUnit: state.local.pressureUnit || 'meter',
}))(PressureSensorAlarmsTab);
